import { useMutation } from '@tanstack/react-query';
import { useBffClient } from './client';
import type {
  BootstrapRequest,
  BootstrapResponse,
  CreateOrganizationRequest,
  CreateOrganizationResponse,
  CreatePersonalOrganizationResponse,
} from '../types/identity';

export function useBootstrapIdentity() {
  const client = useBffClient();
  return useMutation({
    mutationFn: (request: BootstrapRequest) =>
      client.post<BootstrapResponse>('/bff/identity/bootstrap', request),
  });
}

export function useCreateOrganization() {
  const client = useBffClient();
  return useMutation({
    mutationFn: (request: CreateOrganizationRequest) =>
      client.post<CreateOrganizationResponse>('/bff/identity/create-organization', request),
  });
}

/**
 * Creates the caller's free personal organization (epic #121, story #129).
 *
 * NO REQUEST BODY. The platform derives the name from the caller's own registered display name and
 * forces the only provisionable region, so there is nothing here a client could get wrong or lie about.
 *
 * Idempotent on the server: a second call returns the organization that already exists with
 * `created: false`, so a double-clicked button or a retried signup cannot leave someone with two
 * personal organizations named after them.
 */
export function useCreatePersonalOrganization() {
  const client = useBffClient();
  return useMutation({
    mutationFn: () =>
      client.post<CreatePersonalOrganizationResponse>(
        '/bff/identity/create-personal-organization',
      ),
  });
}
